import { render } from "./AddCityZonePage.vue?vue&type=template&id=2d45efa7&ts=true"
import script from "./AddCityZonePage.vue?vue&type=script&lang=ts"
export * from "./AddCityZonePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__